import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { AvatarSelector } from "@/components/User/AvatarSelector";
import { ThemeToggle } from "@/components/Layout/ThemeToggle";
import { Palette, Lock } from "lucide-react";

interface AppearanceSectionProps {
  avatarId: number;
  onAvatarSelect: (avatarId: number) => void;
  isPremium: boolean;
}

export const AppearanceSection = ({ 
  avatarId, 
  onAvatarSelect,
  isPremium 
}: AppearanceSectionProps) => {
  return (
    <Card className="border-border/50 bg-card/50 backdrop-blur-sm">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Palette className="h-5 w-5 text-primary" />
          Appearance
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {/* Theme Toggle */}
        <div className="space-y-2">
          <Label>Theme</Label>
          <div className="flex items-center gap-4">
            <ThemeToggle />
            <span className="text-sm text-muted-foreground">Toggle between light and dark mode</span>
          </div>
        </div>

        {/* Avatar Selection */}
        <div className="space-y-3">
          <Label>Avatar</Label>
          <AvatarSelector
            selectedAvatarId={avatarId}
            onSelectAvatar={onAvatarSelect}
          />
        </div>

        {/* Premium Color Options */}
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <Label className="flex items-center gap-2">
              Custom Colors
              {!isPremium && <Lock className="h-3 w-3 text-muted-foreground" />}
            </Label>
            {!isPremium && (
              <span className="text-xs text-muted-foreground">Premium Feature</span>
            )}
          </div>
          <div className={`grid grid-cols-2 gap-4 ${!isPremium ? 'opacity-50 pointer-events-none' : ''}`}>
            <div className="space-y-2">
              <Label className="text-sm text-muted-foreground">Username Color</Label>
              <div className="h-10 w-full rounded-md border border-border bg-gradient-to-r from-primary via-purple-500 to-pink-500 flex items-center justify-center">
                <span className="text-xs text-white font-medium">Coming Soon</span>
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-sm text-muted-foreground">Post Border Color</Label>
              <div className="h-10 w-full rounded-md border border-border bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 flex items-center justify-center">
                <span className="text-xs text-white font-medium">Coming Soon</span>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
